<template>
  <span class="ml-2 text-warning" v-if="hasProductsByWeight()">
    <font-awesome-icon icon="balance-scale" />
    {{ $t("role.orders.manage.ddmp.detail.delivery.table.priceNotWeighed") }}
  </span>
  <strong v-else>{{ getPrice() }}</strong>
</template>

<script>
import get from "lodash/get";
import { mapGetters } from "vuex";
import { formatPrice } from "../../../../../../helpers/common";

export default {
  name: "ProductsTablePrice",

  data() {
    return {
      data: {},
    };
  },

  computed: {
    ...mapGetters("connections", ["currencySymbol"]),
  },

  methods: {
    getPrice() {
      const price = get(this.data, "order.tot_price", 0);
      return formatPrice(price, this.currencySymbol).format();
    },

    hasProductsByWeight() {
      return get(this.data, "need_w", 0);
    },
  },
};
</script>
